import { format, parseISO } from 'date-fns';
import { sv } from 'date-fns/locale';
import {
    IntervalEntry,
    IntervalEntryConfig,
    IntervalEntryKind,
} from 'api/report/types';
import { getIntervalTimestampParts } from 'report/logic/interval/timestamp';

export function formatMinutes(value: number): string {
    const minutes = Math.round(value);
    const hours = Math.floor(minutes / 60);
    const remainder = minutes % 60;
    return hours
        ? `${hours} h${remainder ? ` ${remainder} min` : ''}`
        : `${remainder} min`;
}

export function formatIntervalRange(
    entry: Pick<IntervalEntry, 'startAt' | 'endAt'>,
    timeZone: string
): {
    startDate: string;
    endDate: string | null;
    startTime: string;
    endTime: string;
} {
    const start = getIntervalTimestampParts(
        Date.parse(entry.startAt),
        timeZone
    );
    const end = getIntervalTimestampParts(Date.parse(entry.endAt), timeZone);
    const showOffsets = start.offset !== end.offset;
    const dateFormat =
        start.date.slice(0, 4) === end.date.slice(0, 4)
            ? 'd MMM'
            : 'd MMM yyyy';
    const formatDate = (date: string) =>
        format(parseISO(date), dateFormat, { locale: sv }).replace(/\./g, '');

    return {
        startDate: formatDate(start.date),
        endDate: start.date === end.date ? null : formatDate(end.date),
        startTime: `${start.time}${showOffsets ? ` (${start.offset})` : ''}`,
        endTime: `${end.time}${showOffsets ? ` (${end.offset})` : ''}`,
    };
}

const kindLabels: Record<IntervalEntryKind, string> = {
    [IntervalEntryKind.NORMAL]: 'Ordinarie tid',
    [IntervalEntryKind.ON_CALL_ON_SITE]: 'Jour',
    [IntervalEntryKind.ON_CALL_OFF_SITE]: 'Beredskap',
    [IntervalEntryKind.DISTURBANCE]: 'Störning',
};

export function formatIntervalKind(
    kind: IntervalEntryKind,
    entryKinds: IntervalEntryConfig[]
): string {
    return (
        entryKinds.find(config => config.kind === kind)?.label ||
        kindLabels[kind]
    );
}
